export const extractNameFromPageTitle = (title = "") => {
	if (title) return title;
	const suffixIndex = document.title.lastIndexOf("| Dimensional");
	return (suffixIndex === -1 ? document.title : document.title.slice(0, suffixIndex)).trim();
};
